export class BOOKING_STATE {
  static Reserved = 1;
  static GuestConfirmed = 2;
  static VenueConfirmed = 3;
  static CancelledVenue = 4;
  static CancelledGuest = 5;
  //static NoShow = 6;
  static Requested = 7;
  static RequestRejected = 8;

  static nameof(bookingState) {
    switch (bookingState) {
      case BOOKING_STATE.Reserved: {
        return 'Reserved';
      }
      case BOOKING_STATE.GuestConfirmed: {
        return 'Guest confirmed';
      }
      case BOOKING_STATE.VenueConfirmed: {
        return 'Venue confirmed';
      }
      case BOOKING_STATE.CancelledVenue: {
        return 'Venue cancelled';
      }
      case BOOKING_STATE.CancelledGuest: {
        return 'Guest cancelled';
      }
      // case BOOKING_STATE.NoShow: {
      //   return 'No show';
      // }
      case BOOKING_STATE.Requested: {
        return 'Requested';
      }
      case BOOKING_STATE.RequestRejected: {
        return 'Requested rejected';
      }
    }
  }

  static colorof(bookingState) {
    switch (bookingState) {
      case BOOKING_STATE.Reserved: {
        return 'red';
      }
      case BOOKING_STATE.GuestConfirmed: {
        return 'black';
      }
      case BOOKING_STATE.VenueConfirmed: {
        return 'black';
      }
      case BOOKING_STATE.CancelledVenue: {
        return 'pink';
      }
      case BOOKING_STATE.CancelledGuest: {
        return 'black';
      }
      // case BOOKING_STATE.NoShow: {
      //   return 'black';
      // }
      case BOOKING_STATE.Requested: {
        return '#a7a748';
      }
      case BOOKING_STATE.RequestRejected: {
        return 'black';
      }
    }
  }

  static iconof(bookingState) {
    switch (bookingState) {
      case BOOKING_STATE.Reserved: {
        return null;
      }
      case BOOKING_STATE.GuestConfirmed: {
        return null;
      }
      case BOOKING_STATE.VenueConfirmed: {
        return null;
      }
      case BOOKING_STATE.CancelledVenue: {
        return null;
      }
      case BOOKING_STATE.CancelledGuest: {
        return null;
      }
      // case BOOKING_STATE.NoShow: {
      //   return 'SlashIcon';
      // }
      case BOOKING_STATE.Requested: {
        return null;
      }
      case BOOKING_STATE.RequestRejected: {
        return null;
      }
    }
  }
}
